import {
    SET_USER,
    SET_ERRORS,
    CLEAR_ERRORS,
    LOADING_UI,
    SET_UNAUTHENTICATED,
    LOADING_USER,
    UPDATE_POST_IMAGE,
    SET_GROUPS
} from "../reducers/types";
import axios from "axios";

export const loginUser = (userData, history) => dispatch => {
    dispatch({ type: LOADING_UI });
    axios
        .post("/login", userData)
        .then(res => {
            setAuthorizationHeader(res.data.token);
            dispatch(getUserData());
            dispatch({ type: CLEAR_ERRORS });
            history.push("/");
        })
        .catch(err => {
            dispatch({
                type: SET_ERRORS,
                payload: err.response.data
            });
        });
};

export const logoutUser = () => dispatch => {
    localStorage.removeItem("FBIdToken");
    delete axios.defaults.headers.common["Authorization"];
    dispatch({ type: SET_UNAUTHENTICATED });
};

export const getUserData = () => dispatch => {
    dispatch({ type: LOADING_USER });
    axios
        .get("/user")
        .then(res => {
            dispatch({
                type: SET_USER,
                payload: res.data
            });
        })
        .catch(err => console.log(err));
};

export const signupUser = (newUserData, history) => dispatch => {
    dispatch({ type: LOADING_UI });
    axios
        .post("/signup", newUserData)
        .then(res => {
            setAuthorizationHeader(res.data.token);
            dispatch(getUserData());
            dispatch({ type: CLEAR_ERRORS });
            history.push("/");
        })
        .catch(err => {
            dispatch({
                type: SET_ERRORS,
                payload: err.response.data
            });
        });
};

export const uploadImage = formData => dispatch => {
    dispatch({ type: LOADING_USER });
    axios
        .post("/user/image", formData)
        .then(() => {
            dispatch(getUserData());
        })
        .catch(err => console.log(err));
};

export const uploadPostImage = formData => dispatch => {
    dispatch({ type: LOADING_UI });
    axios
        .post("/scream/image", formData)
        .then(res => {
            dispatch({ type: CLEAR_ERRORS });
            dispatch({ type: UPDATE_POST_IMAGE, payload: res.data.imageUrl });
        })
        .catch(err => console.log(err));
};

export const editUserDetails = userDetails => dispatch => {
    dispatch({ type: LOADING_USER });
    axios
        .post("/user", userDetails)
        .then(() => {
            dispatch(getUserData());
        })
        .catch(err => console.log(err));
};

const setAuthorizationHeader = token => {
    const FBIdToken = `Bearer ${token}`;
    localStorage.setItem("FBIdToken", FBIdToken);
    axios.defaults.headers.common["Authorization"] = FBIdToken;
};

export const createClassroom = groupDetails => dispatch => {
    dispatch({ type: LOADING_UI });
    axios
        .post("/group/create", groupDetails)
        .then(() => {
            dispatch({ type: CLEAR_ERRORS });
        })
        .catch(err => console.log(err));
};

export const getGroups = () => dispatch => {
    dispatch({ type: LOADING_UI });
    axios
        .get("/group")
        .then(res => {
            dispatch({
                type: SET_GROUPS,
                payload: res.data
            });
            dispatch({ type: CLEAR_ERRORS });
        })
        .catch(err => {
            dispatch({
                type: SET_GROUPS,
                payload: []
            });
        });
};
